import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_reportes_configuracion_id: new EntityColumn<string>({ name: 'c_reportes_configuracion_id', type: 'char', length: 20, flags: c.PK, prompt: 'Reportes Configuracion Id' }),
        vc_tenant_id: new EntityColumn<string>({ name: 'vc_tenant_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tenant Id' }),
        vc_client_id: new EntityColumn<string>({ name: 'vc_client_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Client Id' }),
        vc_secret: new EntityColumn<string>({ name: 'vc_secret', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Secret' }),
        vc_workspace_id: new EntityColumn<string>({ name: 'vc_workspace_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Workspace Id' }),
        vc_report_id: new EntityColumn<string>({ name: 'vc_report_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Report Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        reco_brwStandard: { name: 'reco_brwStandard', keyMappings: { c_reportes_configuracion_id: 0 } }
    }
)

export class ReportesConfiguracionDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('ReportesConfiguracion');
    }
}